import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Pagination from './pagination'
import {
  getWork,
  getMediaKey
} from '../../../../../../stores/works/works.selectors'
import { setMedia } from '../../../../../../stores/works/works.actions'

const mapStateToProps = (state, { match }) => {
  const work = getWork(state, match.params.workId)
  return {
    total: work.media && work.media.length,
    current: getMediaKey(state)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onNext: () => {
    const { current, total } = stateProps
    const page = current !== total - 1 ? current + 1 : current
    return dispatch(setMedia(page))
  },
  onPrev: () => {
    const { current } = stateProps
    const page = !current ? current : current - 1
    return dispatch(setMedia(page))
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(Pagination)
)
